import { TDictionary } from '@/common/types/dictionary';

export const moveStatisticsTabsToTopLevel = (clonedElement: HTMLElement) => {
  const body = clonedElement.querySelector('.export-body') as HTMLElement | null;
  if (!body) return;

  const bodyChildren = Array.from(body.children) as HTMLElement[];
  const filterContainer = bodyChildren.find((el) => el.matches('.filter-factory')) ?? body;
  const wrapper = document.createElement('div');
  body.insertBefore(wrapper, filterContainer);
  wrapper.appendChild(filterContainer);

  const sections = Array.from(body.querySelectorAll('.statistics-tabs')) as HTMLElement[];

  sections.forEach((section) => {
    const titleEl = section.querySelector('.statistics-tabs__title') as HTMLElement | null;
    const tabs = Array.from(section.querySelectorAll('.tab-switcher__tab')) as HTMLElement[];

    if (titleEl && tabs.length > 0) {
      const group = document.createElement('div');
      group.className = 'pdf-keep-with-next';
      wrapper.appendChild(group);
      group.appendChild(titleEl);

      tabs.forEach((tab, index) => {
        if (index === 0) {
          group.appendChild(tab);
        } else {
          wrapper.appendChild(tab);
        }
      });
    } else {
      if (titleEl) {
        wrapper.appendChild(titleEl);
      }

      tabs.forEach((tab) => {
        wrapper.appendChild(tab);
      });
    }

    section.remove();
  });
};

const FILTER_FONT_SIZE = '14px';
const FILTER_LINE_HEIGHT = '20px';

const getFilterValueText = (block: HTMLElement): string => {
  const dateInputs = Array.from(block.querySelectorAll('.v3dp__input_wrapper input')) as HTMLInputElement[];

  if (dateInputs.length) {
    return dateInputs
      .map((input) => input.value || input.getAttribute('placeholder') || '')
      .filter(Boolean)
      .join(' — ');
  }

  const selected = block.querySelector('.hierarchical-multiselect__selected-text, .multiselect-single-label-text');

  if (selected) return (selected.textContent ?? '').trim();

  const placeholder = block.querySelector('.hierarchical-multiselect__placeholder, .multiselect-placeholder');

  if (placeholder) return (placeholder.textContent ?? '').trim();

  const input = block.querySelector('input') as HTMLInputElement | null;

  return input ? input.value || input.getAttribute('placeholder') || '' : '';
};

const createFilterTextNode = (text: string, fontWeight: string) => {
  const node = document.createElement('p');

  node.textContent = text;
  node.style.margin = '0';
  node.style.fontSize = FILTER_FONT_SIZE;
  node.style.lineHeight = FILTER_LINE_HEIGHT;
  node.style.fontWeight = fontWeight;
  node.style.wordBreak = 'break-word';

  return node;
};

/**
 * Переводим инпуты в текст, так как это пдф и они не интерактивны
 * @param clonedElement клон контейнера `.export-page`, попадающий в экспорт
 */
export const replaceFiltersWithText = (clonedElement: HTMLElement) => {
  const filters = clonedElement.querySelector('.filter-factory__filters') as HTMLElement | null;

  if (!filters) return;

  const originalBlocks = Array.from(
    document.querySelectorAll('.export-page .filter-factory__filters .custom-form__inputBlock'),
  );

  const rows = Array.from(filters.querySelectorAll('.custom-form__inputBlock')).map((el, index) => {
    const block = (originalBlocks[index] ?? el) as HTMLElement;
    const label = (block.querySelector('.custom-form__label')?.textContent ?? '').trim();

    return { label, value: getFilterValueText(block) };
  });

  filters.innerHTML = '';
  filters.style.display = 'grid';
  filters.style.gridTemplateColumns = 'max-content 1fr';
  filters.style.gap = '4px 8px';
  filters.style.alignItems = 'start';

  rows.forEach(({ label, value }) => {
    const labelText = label && !label.endsWith(':') ? `${label}:` : label;

    filters.append(createFilterTextNode(labelText, '600'), createFilterTextNode(value, '400'));
  });
};

/**
 *  Фильтрует организации и возвращает все, кроме Министерства экономического развития
 * @param item DTO - организации
 * @returns {Boolean} true - если организации не является МИНЭК
 */
export const filterMinekOrganization = (item: TDictionary) => {
  return item.id !== 1;
};
